import {clsx} from "clsx";
import secureLocalStorage from "react-secure-storage";
import {twMerge} from "tailwind-merge";

import {moment} from "@/src/modules/core/lib";

export const ITEMS_PER_PAGE = 10;

export const clearStore = () => {
  Object.keys(localStorage).forEach((key) => {
    localStorage.setItem(key, null);
  });
};

export const setStorageItem = (key, data) => {
  secureLocalStorage.setItem(key, JSON.stringify(data));
};

export const getStorageItem = (key, parse = true) => {
  const data = secureLocalStorage.getItem(key);
  return parse ? (data ? JSON.parse(data) : null) : data;
};

export const utcToLocale = (date) => {
  const momentObj = moment.utc(date);
  const userOffset = moment().utcOffset();
  const localMomentObj = momentObj.utcOffset(userOffset);
  const formattedDateTime = localMomentObj.format("MM/DD/yy HH:mm");

  return new Date(formattedDateTime);
};

export const dateToUTC = (date) => {
  return new Date(`${date}T00:00:00`);
};

// export async function downloadFromUrl(url, filename) {
//   const response = await fetch(url);
//   const blob = await response.blob();
//   const anchor = document.createElement("a");

//   anchor.href = URL.createObjectURL(blob);
//   anchor.download = filename;
//   document.body.appendChild(anchor);
//   anchor.click();
//   document.body.removeChild(anchor);
// }

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
